import React, { useEffect, useState } from "react";
import styled, { keyframes, css } from "styled-components";
import { ReactComponent as TopImg } from "../common/image/gacha/top.svg";
import { ReactComponent as BottomImg } from "../common/image/gacha/bottom.svg";
import { isMobile } from "../common/style";
import ShareKakaoBtn from "../ShareSNS/ShareKakaoBtn";

type CapsuleType = {
  data: string[];
  big: boolean;
  length: number;
};

const CapsulePage: React.FC<CapsuleType> = ({ data, big, length }) => {
  const [end, setEnd] = useState(false);
  const [btn, setBtn] = useState(false);
  const [count, setCount] = useState(0);
  const [disabled, setDisabled] = useState(false);

  const bigAnimationEnd = () => {
    setTimeout(() => {
      setEnd(true);
    }, 1000);
  };

  const btnAnimationEnd = () => {
    setTimeout(() => {
      setBtn(true);
    }, 100);
  };

  useEffect(() => {
    if (length - 1 === count) {
      setDisabled(true);
    }
  }, [count, disabled, length]);

  const ReHandler = () => {
    setEnd(false);
    setBtn(false);
    setCount((count) => count + 1);
  };

  return (
    <>
      {end ? (
        <>
          <CapsuleEndDiv end={end ? 1 : 0}>
            <TopImg
              className="capsuleimg capsuletopimg"
              onAnimationEnd={btnAnimationEnd}
              style={{ zIndex: "150" }}
            />
            <h2 className="capsuledata">{data[count]}</h2>
            <BottomImg
              className="capsuleimg capsulebottomimg"
              style={{ zIndex: "50" }}
            />
          </CapsuleEndDiv>
          {btn && (
            <ButtonDiv btn={btn ? 1 : 0}>
              <button onClick={ReHandler} disabled={disabled}>
                다시 뽑기
              </button>
              <button onClick={() => window.location.replace("/")}>
                새로 뽑기
              </button>
            </ButtonDiv>
          )}
          {btn && (
            <ButtonKakaoDiv btn={btn ? 1 : 0}>
              <ShareKakaoBtn food={data[count]} />
            </ButtonKakaoDiv>
          )}
        </>
      ) : (
        <CapsuleDiv big={big ? 1 : 0}>
          <TopImg
            className="capsuleimg"
            onAnimationEnd={bigAnimationEnd}
            style={{ zIndex: "150" }}
          />
          <BottomImg className="capsuleimg" style={{ zIndex: "50" }} />
        </CapsuleDiv>
      )}
    </>
  );
};

export default CapsulePage;

const bigAnimation = keyframes`
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(4) translateY(-16%);
  }
`;

const bigAnimationmoblie = keyframes`
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(4) translateY(-14%);
  }
`;

const topAnimation = keyframes`
  0% {
    transform: translate(0);
  }
  100% {
    transform: rotate(23deg) translate(30px, -80px);
  }
`;

const topAnimationmoblie = keyframes`
  0% {
    transform: translateY(-14%);
  }
  100% {
    transform: rotate(20deg) translate(10px, -110px);
  }
`;

const bottomAnimation = keyframes`
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(15%);
  }
`;

const bottomAnimationmoblie = keyframes`
  0% {
    transform: translateY(-9%);
  }
  100% {
    transform: translateY(-4%);
  }
`;

const bottomtextAnimation = keyframes`
  0% {
    transform: translateY(410%);
  }
  100% {
    transform: translateY(545%);
  }
`;

const bottomtextAnimationmoblie = keyframes`
  0% {
    transform: translateY(390%);
  }
  100% {
    transform: translateY(450%);
  }
`;

const btnAnimation = keyframes`
  0% {
    transform: translateY(220%);
  }
  100% {
    transform: translateY(230%);
  }
`;

const btnAnimationmoblie = keyframes`
  0% {
    transform: translateY(255%);
  }
  100% {
    transform: translateY(265%);
  }
`;

const btnkakaoAnimationmoblie = keyframes`
  0% {
    transform: translateY(120%);
  }
  100% {
    transform: translateY(143%);
  }
`;

const CapsuleDiv = styled.div<{ big: number }>`
  position: relative;
  top: 51%;
  z-index: 65;
  display: flex;
  justify-content: center;

  ${isMobile} {
    top: 44%;
  }

  .capsuleimg {
    position: absolute;
    width: 80px;
    animation: ${({ big }) =>
      big
        ? css`
            ${bigAnimation} 1s ease-in-out forwards
          `
        : "none"};

    ${isMobile} {
      width: 50px;
      animation: ${({ big }) =>
        big
          ? css`
              ${bigAnimationmoblie} 1s ease-in-out forwards
            `
          : "none"};
    }
  }
`;

const CapsuleEndDiv = styled.div<{ end: number }>`
  position: relative;
  z-index: 65;
  display: flex;
  justify-content: center;

  .capsuleimg {
    position: absolute;
    width: 320px;

    ${isMobile} {
      width: 200px;
    }
  }

  .capsuletopimg {
    animation: ${({ end }) =>
      end
        ? css`
            ${topAnimation} 1s ease-in-out forwards
          `
        : "none"};

    ${isMobile} {
      animation: ${({ end }) =>
        end
          ? css`
              ${topAnimationmoblie} 1s ease-in-out forwards
            `
          : "none"};
    }
  }

  .capsulebottomimg {
    animation: ${({ end }) =>
      end
        ? css`
            ${bottomAnimation} 1s ease-in-out forwards
          `
        : "none"};

    ${isMobile} {
      animation: ${({ end }) =>
        end
          ? css`
              ${bottomAnimationmoblie} 1s ease-in-out forwards
            `
          : "none"};
    }
  }

  .capsuledata {
    position: absolute;
    z-index: 100;
    color: #7d5959;
    font-family: GmarketSansBold;
    font-size: 33px;
    font-weight: 700;
    animation: ${({ end }) =>
      end
        ? css`
            ${bottomtextAnimation} 1s ease-in-out forwards
          `
        : "none"};

    ${isMobile} {
      font-size: 28px;
      animation: ${({ end }) =>
        end
          ? css`
              ${bottomtextAnimationmoblie} 1s ease-in-out forwards
            `
          : "none"};
    }
  }
`;

const ButtonDiv = styled.div<{ btn: number }>`
  display: flex;
  flex-direction: column;
  float: right;
  animation: ${({ btn }) =>
    btn
      ? css`
          ${btnAnimation} 0.5s forwards
        `
      : "none"};

  ${isMobile} {
    animation: ${({ btn }) =>
      btn
        ? css`
            ${btnAnimationmoblie} 0.5s forwards
          `
        : "none"};
  }

  button {
    width: 149px;
    height: 56px;
    border-radius: 100px;
    border: 3px solid #7d5959;
    background: #fff5f5;
    color: #7d5959;
    font-family: GmarketSansBold;
    font-size: 22px;
    font-weight: 700;
    margin-bottom: 10px;
    cursor: pointer;

    ${isMobile} {
      width: 140px;
      height: 50px;
      font-size: 20px;
      margin-bottom: 7px;
      border: 2px solid #7d5959;
    }

    &:hover {
      background: #ebcece;
    }

    &:disabled {
      background: #fff5f5;
      cursor: default;
    }
  }
`;

const ButtonKakaoDiv = styled.div<{ btn: number }>`
  display: flex;
  flex-direction: column;
  float: left;
  margin-top: 220px;
  animation: ${({ btn }) =>
    btn
      ? css`
          ${btnAnimation} 0.5s forwards
        `
      : "none"};

  ${isMobile} {
    animation: ${({ btn }) =>
      btn
        ? css`
            ${btnkakaoAnimationmoblie} 0.52s forwards
          `
        : "none"};
  }
`;
